export default {
  ptbr: {
    application: {
      logout: 'Encerrar sessão',
      name: 'PBCONSIG - Servidores',
      subtitles: ['Secretaria de Estado', 'da Administração'],
    },
  },
}
